/* iceberg-ui */
import { HalfPieChart } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { useTheme } from '@mui/material/styles';
import { CellContext } from '@tanstack/react-table';

/* Shared */
import { FontSizes } from 'application/Shared/Constants';
import { Helpers } from 'application/Shared/Helpers';
import {
    ClientLink,
    UnclassifiedRisks
} from 'application/Shared/types/clientLink';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip as ChartTooltip } from 'recharts';

/* Internal */
import { usePartnerClientsTableContext } from './PartnerClientsTableContext';

/*  Constants  */
const { isset, isEmpty } = Helpers;

export const UnclassifiedBreakdownCell = ({
    row
}: CellContext<ClientLink, unknown>) => {
    const { t } = useTranslation();
    const { clientApps } = usePartnerClientsTableContext();
    const theme = useTheme();
    const { id } = row.original;

    let risks: UnclassifiedRisks[] = [];
    if (isset(clientApps, id)) {
        const { applicationBreakdown } = clientApps[id];
        if (!isEmpty(applicationBreakdown)) {
            risks = applicationBreakdown?.unclassifiedRisks ?? [];
        }
    }

    return (
        <HalfPieChart
            data={risks}
            emptyMessage={t('Common.noData')}
            isAnimationActive={false}
            isRiskChart
            emptyMessageFontSize={FontSizes[1]}
            noLegend
            responsiveContainerHeight={45}
            tooltip={
                <ChartTooltip
                    allowEscapeViewBox={{ x: true, y: true }}
                    contentStyle={{ paddingBottom: 0, paddingTop: 0 }}
                    formatter={(value, text) => [
                        t('Risk.numberAppsAtRiskLevel', { text, value }),
                        null
                    ]}
                    itemStyle={{
                        color: theme.palette.text.primary,
                        margin: 0,
                        whiteSpace: 'normal',
                        width: '100px'
                    }}
                    position={{ x: 110, y: -32 }}
                    wrapperStyle={{
                        padding: 0,
                        zIndex: 1000
                    }}
                />
            }
        />
    );
};
